import { render, staticRenderFns } from "./AcademicFundsRemaining.vue?vue&type=template&id=bdd4a410&scoped=true"
import script from "./AcademicFundsRemaining.vue?vue&type=script&lang=js"
export * from "./AcademicFundsRemaining.vue?vue&type=script&lang=js"
import style0 from "./AcademicFundsRemaining.vue?vue&type=style&index=0&id=bdd4a410&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd4a410",
  null
  
)

export default component.exports